export default __webpack_public_path__ + "static/media/mar-gameboard-01-riverbed.04052598.png";